<template>
  <FormCard class="contact-card">
    <template #header>
      <div class="card-header-row">
        <span>교사 정보</span>
        <div class="card-header-actions">
          <v-btn
            v-if="contactDirty"
            @click="updatecontact()"
            variant="flat"
            size="small"
            class="btn-primary"
          >저장</v-btn>
          <v-btn
            @click="addcontact()"
            variant="outlined"
            size="small"
            class="btn-secondary"
          >+ 연락처 추가</v-btn>
        </div>
      </div>
    </template>

    <div class="teacher-list">
      <div v-if="contactlist.length" class="teacher-list__header">
        <span class="teacher-unit__name">이름</span>
        <span class="teacher-unit__tel">연락처</span>
        <span class="teacher-unit__mail">이메일</span>
      </div>
      <!-- 수동 등록 연락처(isLMS=false)는 하늘색 배경으로 LMS 인증 정보와 구분 (new-requests-1018 #2) -->
      <div
        v-for="(j, i) in contactlist"
        :key="i"
        class="teacher-unit"
        :class="{ 'teacher-unit--manual': !j.isLMS }"
      >
        <input v-model="j.name" spellcheck="false" type="text" placeholder="성함" class="cell-input teacher-unit__name" />
        <input v-model="j.tel" spellcheck="false" type="text" placeholder="연락처" class="cell-input teacher-unit__tel" />
        <input v-model="j.mail" spellcheck="false" type="text" placeholder="이메일" class="cell-input teacher-unit__mail" />
        <button
          @click="deletecontact(i)"
          class="teacher-unit__delete"
          aria-label="삭제"
        >✖</button>
      </div>
    </div>
  </FormCard>
</template>

<script>
import { FormCard } from "@/components/ui";

export default {
  components: { FormCard },
  data() {
    return {
      contactSnapshot: "",
    };
  },
  props: {
    contactlist_origin: { type: Array },
    contactlist: { type: Array },
  },
  created() {
    this.contactSnapshot = JSON.stringify(this.contactlist);
  },
  computed: {
    contactDirty() {
      return JSON.stringify(this.contactlist) !== this.contactSnapshot;
    },
  },
  methods: {
    addcontact() {
      this.contactlist.push({
        name: "",
        mail: "",
        tel: "",
        memo: "",
        isLMS: false,
      });
    },
    deletecontact(index) {
      if (this.contactlist[index]["isLMS"] === true) {
        alert("자동 추가 연락처는 삭제할 수 없습니다.");
        return;
      }
      this.contactlist.splice(index, 1);
    },
    async updatecontact() {
      const schoolCode = this.$route.params.code;
      const contactList = this.contactlist.filter(
        (item) => item.isLMS === false,
      );
      for (let i = 0; i < contactList.length; i++) {
        if (!contactList[i].telCheck) contactList[i].telCheck = false;
        if (!contactList[i].mailCheck) contactList[i].mailCheck = false;
      }
      const res = await this.$store.dispatch("UPDATE_CONTACT", {
        schoolCode,
        contactList,
      });
      if (res) {
        alert("연락처 업데이트가 완료되었습니다.");
        this.contactSnapshot = JSON.stringify(this.contactlist);
      } else {
        alert("연락처 업데이트에 실패하였습니다.");
      }
    },
  },
};
</script>

<style scoped>
.card-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-2) var(--space-4);
}

.card-header-actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.btn-primary {
  background: var(--color-primary-600) !important;
  color: var(--text-on-primary) !important;
  height: 28px !important;
  font-size: var(--font-small-size) !important;
}

.btn-secondary {
  color: var(--text-primary) !important;
  border-color: var(--border-strong) !important;
  height: 28px !important;
  font-size: var(--font-small-size) !important;
}

.teacher-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
}

.teacher-list__header {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: var(--font-caption-size, 12px);
  font-weight: 600;
  color: var(--text-tertiary);
}

.teacher-unit {
  display: flex;
  align-items: center;
  gap: var(--space-1);
}

.teacher-unit__name {
  width: 90px;
}

.teacher-unit__tel {
  width: 130px;
}

.teacher-unit__mail {
  width: 180px;
}

/* input에는 .cell-input(width:100%)이 함께 붙어 있어, 위 너비 지정이
   선언 순서상 뒤에 오는 .cell-input에 덮여써 헤더(span)와 어긋나 보였다.
   같은 요소에 두 클래스가 같이 붙는 조합 선택자로 명시해 순서와 무관하게
   고정 너비가 이기도록 한다. */
.teacher-unit__name.cell-input,
.teacher-unit__tel.cell-input,
.teacher-unit__mail.cell-input {
  flex: 0 0 auto;
}
.teacher-unit__name.cell-input {
  width: 90px;
}
.teacher-unit__tel.cell-input {
  width: 130px;
}
.teacher-unit__mail.cell-input {
  width: 180px;
}

.teacher-unit__delete {
  font-size: 14px;
  color: var(--color-error-text);
  cursor: pointer;
  line-height: 1;
  flex-shrink: 0;
}

.cell-input {
  width: 100%;
  padding: var(--space-1) var(--space-2);
  border: 1px solid transparent;
  background: transparent;
  font-size: var(--font-body-size);
  color: var(--text-primary);
  border-radius: var(--radius-sm);
}

.cell-input:not(:read-only) {
  border-color: var(--border-default);
  background: var(--bg-surface-raised);
}

/* 수동 등록 연락처(isLMS=false) 전체를 하늘색으로 — LMS 인증 정보와 구분.
   기존 last-child 규칙(마지막 입력줄만)은 이 규칙의 특수 케이스라 대체됨 (new-requests-1018 #2) */
.teacher-unit--manual .cell-input {
  background: #eaf6ff;
}

.contact-card :deep(.form-card) {
  padding-bottom: var(--space-4);
}
</style>
